export default "__VITE_ASSET__DgIDJfjU__"